export default "__VITE_ASSET__DlQTKqW7__";